export const COLORS = [
    '#FF6384',
    '#36A2EB',
    '#FFCE56',
    '#4bc0c0',
    '#9966FF',
    '#FF9F40',
    '#C9CBCF',
    '#8BC34A',
    '#00BCD4',
    '#CDDC39',
    '#FF6B6B',
    '#6B5B95',
    '#88B04B',
    '#F7CAC9',
    '#92A8D1',
    '#955251',
    '#B565A7',
    '#009B77',
    '#DD4124',
    '#45B8AC',
    // Add more colors if needed
];


export const GRADIENT_COLORS = {
    totalMileage: {
      start: 'rgba(153, 102, 255, 0.6)',
      end: 'rgba(153, 102, 255, 1)',
      border: '#9966ff',
    },
    averageConsumption: {
      start: 'rgba(75, 192, 192, 0.6)',
      end: 'rgba(75, 192, 192, 1)',
      border: '#4bc0c0',
    },
    // ... other gradients if needed
  };
  